import React, { useState } from "react";
import { FaUserTie } from "react-icons/fa";
import AddWithdrawDetails from "../AddWithdrawDetails/AddWithdrawDetails";
import Helper from "../../helper";
// import Header from "../header/Header";
// import ExposureHeader from '../ExposureHeader/ExposureHeader';
// import Footer from "../Footer/Footer";

const Profile = () => {
  const userInfo = Helper();

  const [showEditPopup, setShowEditPopup] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [editingSection, setEditingSection] = useState(null);

  const [bankDetails, setBankDetails] = useState();

  const [UPIDetails, setUPIDetails] = useState();

  const handleBankInputChange = (e) => {
    const { name, value } = e.target;
    setBankDetails({ ...bankDetails, [name]: value });
  };

  const handleUPIInputChange = (e) => {
    const { name, value } = e.target;
    setUPIDetails({ ...UPIDetails, [name]: value });
  };

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const toggleEditPopup = (section) => {
    setEditingSection(section);
    setShowEditPopup(!showEditPopup);
  };
  const [ifscCode, setIfscCode] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [accountHolder, setAccountHolder] = useState("");
  const [bankName, setBankName] = useState("");
  const [upiId, setUpiId] = useState("");
  const [upiHolder, setUpiHolder] = useState("");
  const [showPreviousAccount, setShowPreviousAccount] = useState(false);
  const [selectedPaymentDetail, setSelectedPaymentDetail] = useState(null); // Track selected payment method detail
  const [showUpiForm, setShowUpiForm] = useState('');

  function selectPaymentDetail(detail) {
    setBankName(detail?.bankName);
    setAccountNumber(detail?.accountNo);
    setAccountHolder(detail?.accountHolder);
    setIfscCode(detail?.ifscCode);
    setUpiId(detail?.upiId);
    setUpiHolder(detail?.holderName);
    setShowUpiForm(detail?.type);
    setSelectedPaymentDetail(detail); // Set selected payment method detail
    setShowPreviousAccount(true); // Show details section
  }

  return (
    <div className="min-h-screen bg-gray-100 text-gray-800">
      {/* <Header /> */}
      {/* <ExposureHeader /> */}
      <div title="Settings"
        class="sticky top-0 w-full bg-bg_color_primary py-2.5 px-3 flex items-center justify-between lg:hidden border-t border-border_color_primary font-lato">
        <div class="flex items-center gap-2 w-full">
          <button
            class="relative overflow-hidden bg-bg_color_quaternary rounded w-6 h-6 flex items-center justify-center"
            type="button">
            <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12"
              fill="none" class="text-text_color_primary1">
              <path
                d="M5.3673 11.2346L0 5.8673L5.3673 0.5L6.32 1.4527L1.90539 5.8673L6.32 10.2819L5.3673 11.2346Z"
                fill="var(--icon-color-brand-primary)" />
            </svg>
          </button>
          <div class="flex-1 flex items-center justify-between">
            <h3 class="text-text_color_primary1 text-base font-bold">Profile</h3>
          </div>
        </div>
      </div>

      <div className="p-2 max-w-5xl mx-auto">

        <div className="flex flex-col gap-6">
          {/* Small Profile Card */}
          <div className="flex items-center gap-4 bg-white rounded-lg p-6 shadow">
            <FaUserTie size={60} color="#0c9971" />
            <div>
              {/* <p className="text-sm font-medium">Account</p> */}
              <p className="text-lg font-bold text-[#0c9971]">{userInfo?.user_name}</p>
            </div>
          </div>

          {/* Add Withdraw Button */}
          {/* <div className="flex justify-end">
            <button
              onClick={togglePopup}
              className="bg-[#0c9971] text-white px-4 py-2 rounded font-semibold hover:bg-[#0a7f5e] transition"
            >
              Add Withdraw Details
            </button>
          </div> */}

          
        </div>
      </div>

      {selectedPaymentDetail && (
  <div className="bg-white shadow-md rounded-xl p-5 max-w-3xl mx-auto mt-4">
    <h1 className="text-[#0c9971] text-lg font-semibold mb-4">
      {selectedPaymentDetail.type === "Bank"
        ? "Bank Details"
        : `${selectedPaymentDetail.type} Details`}
    </h1>

    <div className="overflow-x-auto">
      <table className="w-full text-sm sm:text-base text-gray-800">
        <tbody>
          {selectedPaymentDetail.type === "Bank" ? (
            <>
              <tr className="border-b">
                <td className="py-2 font-medium w-1/3">Name</td>
                <td className="text-center w-4">-</td>
                <td className="pl-2">{selectedPaymentDetail?.accountHolder || "-"}</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-medium">A/c Number</td>
                <td className="text-center">-</td>
                <td className="pl-2">{selectedPaymentDetail?.accountNo || "-"}</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-medium">IFSC Code</td>
                <td className="text-center">-</td>
                <td className="pl-2">{selectedPaymentDetail?.ifscCode || "-"}</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-medium">Bank Name</td>
                <td className="text-center">-</td>
                <td className="pl-2">{selectedPaymentDetail?.bankName || "-"}</td>
              </tr>
              {selectedPaymentDetail?.upiId && (
                <tr className="border-b">
                  <td className="py-2 font-medium">UPI ID</td>
                  <td className="text-center">-</td>
                  <td className="pl-2">{selectedPaymentDetail?.upiId}</td>
                </tr>
              )}
            </>
          ) : (
            <>
              <tr className="border-b">
                <td className="py-2 font-medium">{selectedPaymentDetail.type} ID</td>
                <td className="text-center">-</td>
                <td className="pl-2">{selectedPaymentDetail?.upiId || "-"}</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-medium">Holder Name</td>
                <td className="text-center">-</td>
                <td className="pl-2">{selectedPaymentDetail?.holderName || "-"}</td>
              </tr>
            </>
          )}
        </tbody>
      </table>
    </div>
  </div>
)}


      {/* Edit Popup Modal */}
      {/* {showEditPopup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="bg-white w-full max-w-md p-6 rounded-lg shadow-lg">
            <h2 className="text-xl font-bold mb-4 text-[#0c9971]">
              Edit {editingSection === "bank" ? "Bank Details" : "UPI Details"}
            </h2>
            <form className="space-y-4">
              {editingSection === "bank" ? (
                <>
                  <div>
                    <label className="block font-semibold mb-1">Name</label>
                    <input
                      name="name"
                      value={bankDetails.name}
                      onChange={handleBankInputChange}
                      className="w-full px-3 py-2 border rounded focus:outline-none focus:ring focus:border-[#0c9971]"
                    />
                  </div>
                  <div>
                    <label className="block font-semibold mb-1">A/c Number</label>
                    <input
                      name="accountNumber"
                      value={bankDetails.accountNumber}
                      onChange={handleBankInputChange}
                      className="w-full px-3 py-2 border rounded focus:outline-none focus:ring focus:border-[#0c9971]"
                    />
                  </div>
                  <div>
                    <label className="block font-semibold mb-1">IFSC Code</label>
                    <input
                      name="ifscCode"
                      value={bankDetails.ifscCode}
                      onChange={handleBankInputChange}
                      className="w-full px-3 py-2 border rounded focus:outline-none focus:ring focus:border-[#0c9971]"
                    />
                  </div>
                  <div>
                    <label className="block font-semibold mb-1">Bank Name</label>
                    <input
                      name="bankName"
                      value={bankDetails.bankName}
                      onChange={handleBankInputChange}
                      className="w-full px-3 py-2 border rounded focus:outline-none focus:ring focus:border-[#0c9971]"
                    />
                  </div>
                </>
              ) : (
                <>
                  <div>
                    <label className="block font-semibold mb-1">UPI ID</label>
                    <input
                      name="upi_id"
                      value={UPIDetails.upi_id}
                      onChange={handleUPIInputChange}
                      className="w-full px-3 py-2 border rounded focus:outline-none focus:ring focus:border-[#0c9971]"
                    />
                  </div>
                  <div>
                    <label className="block font-semibold mb-1">Phone Number</label>
                    <input
                      name="phoneNumber"
                      value={UPIDetails.phoneNumber}
                      onChange={handleUPIInputChange}
                      className="w-full px-3 py-2 border rounded focus:outline-none focus:ring focus:border-[#0c9971]"
                    />
                  </div>
                </>
              )}

              <div className="flex justify-end gap-4 mt-4">
                <button
                  type="button"
                  className="bg-[#0c9971] text-white px-4 py-2 rounded hover:bg-[#0a7f5e]"
                  onClick={toggleEditPopup}
                >
                  Save
                </button>
                <button
                  type="button"
                  className="bg-gray-300 px-4 py-2 rounded hover:bg-gray-400"
                  onClick={toggleEditPopup}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )} */}

      {/* {showPopup && <AddWithdrawDetails togglePopup={togglePopup} />} */}
      {/* <Footer /> */}
    </div>
  );
};

export default Profile;
